import { get } from '@/axios'

export interface ISearchAuthorRequest {
  keyword: string
  page?: number
  size?: number
}

export type ISearchAuthorResponse = {
  count: number
  list: ISearchAuthorItem[]
}

export interface ISearchAuthorItem {
  author_id: string
  avatar: string
  name: string
  nickname: string
  user_id: string
  follower_count: number
  following_count: number
}

export const searchAuthor = async (params: ISearchAuthorRequest, signal?: AbortSignal) => {
  const response = await get<ISearchAuthorResponse>(`/v2/search/author`, params, {}, { signal: signal })

  return response
}
